export const CAN_VIEW_ALL_USERS = 'AC-2310-UL-002'
export const CAN_EDIT_DELETE_ALL_USERS = 'AC-2310-UL-003'
export const CAN_RUN_ALL_ACTIVITIES = 'AC-2310-UUL-004'
export const ENT_CAN_VIEW_AUDIT_LOGS='AF-2503-ENT-001'
export const ENT_CAN_LOCK_UNLOCK_USERS ='AF-2503-ENT-002'